<div class="row error-container align-items-center justify-content-center">
    <header>
        <img [src]="loginLogo">
    </header>
    <div class="error-body align-items-center justify-content-center">
        <span class="error-num">Error 404</span>
        <h1>Sorry, the page you are looking for cannot be found.</h1>
        <div class="error-text">
            Please check the URL or visit the homepage using the link below.
        </div>
        <a class="btn-cancel" [routerLink]="['/login']">Homepage</a>
    </div>
    <footer class="align-items-center justify-content-center">
        <a href="https://verve.com/contact/" target="_blank">Contact us</a>
        <span>©Verve 2024</span>
    </footer>
</div>